{
  "languageCode": "ru",
  "name": "Русский",
  "direction": "ltr",
  "minimumWordLength": 2,
  "maximumWordLength": 12,
  "groups": [
    {
      "id": "vowel",
      "minimum": 5,
      "maximum": 8
    },
    {
      "id": "consonant",
      "minimum": 4,
      "maximum": 6
    }
  ],
  "letters": [
    {
      "id": "ru-0",
      "symbol": "а",
      "points": 1,
      "group": "vowel",
      "weight": 9.38,
      "enabled": true,
      "sortOrder": 0
    },
    {
      "id": "ru-1",
      "symbol": "б",
      "points": 3,
      "group": "consonant",
      "weight": 1.7,
      "enabled": true,
      "sortOrder": 1
    },
    {
      "id": "ru-2",
      "symbol": "в",
      "points": 2,
      "group": "consonant",
      "weight": 3.62,
      "enabled": true,
      "sortOrder": 2
    },
    {
      "id": "ru-3",
      "symbol": "г",
      "points": 3,
      "group": "consonant",
      "weight": 1.52,
      "enabled": true,
      "sortOrder": 3
    },
    {
      "id": "ru-4",
      "symbol": "д",
      "points": 3,
      "group": "consonant",
      "weight": 2.4,
      "enabled": true,
      "sortOrder": 4
    },
    {
      "id": "ru-5",
      "symbol": "е",
      "points": 1,
      "group": "vowel",
      "weight": 6.56,
      "enabled": true,
      "sortOrder": 5
    },
    {
      "id": "ru-6",
      "symbol": "ё",
      "points": 5,
      "group": "vowel",
      "weight": 0.43,
      "enabled": true,
      "sortOrder": 6
    },
    {
      "id": "ru-7",
      "symbol": "ж",
      "points": 5,
      "group": "consonant",
      "weight": 0.76,
      "enabled": true,
      "sortOrder": 7
    },
    {
      "id": "ru-8",
      "symbol": "з",
      "points": 3,
      "group": "consonant",
      "weight": 1.87,
      "enabled": true,
      "sortOrder": 8
    },
    {
      "id": "ru-9",
      "symbol": "и",
      "points": 1,
      "group": "vowel",
      "weight": 8.06,
      "enabled": true,
      "sortOrder": 9
    },
    {
      "id": "ru-10",
      "symbol": "й",
      "points": 3,
      "group": "consonant",
      "weight": 2.31,
      "enabled": true,
      "sortOrder": 10
    },
    {
      "id": "ru-11",
      "symbol": "к",
      "points": 2,
      "group": "consonant",
      "weight": 4.62,
      "enabled": true,
      "sortOrder": 11
    },
    {
      "id": "ru-12",
      "symbol": "л",
      "points": 2,
      "group": "consonant",
      "weight": 3.88,
      "enabled": true,
      "sortOrder": 12
    },
    {
      "id": "ru-13",
      "symbol": "м",
      "points": 3,
      "group": "consonant",
      "weight": 2.33,
      "enabled": true,
      "sortOrder": 13
    },
    {
      "id": "ru-14",
      "symbol": "н",
      "points": 1,
      "group": "consonant",
      "weight": 6.16,
      "enabled": true,
      "sortOrder": 14
    },
    {
      "id": "ru-15",
      "symbol": "о",
      "points": 1,
      "group": "vowel",
      "weight": 8.74,
      "enabled": true,
      "sortOrder": 15
    },
    {
      "id": "ru-16",
      "symbol": "п",
      "points": 2,
      "group": "consonant",
      "weight": 3.17,
      "enabled": true,
      "sortOrder": 16
    },
    {
      "id": "ru-17",
      "symbol": "р",
      "points": 2,
      "group": "consonant",
      "weight": 5.49,
      "enabled": true,
      "sortOrder": 17
    },
    {
      "id": "ru-18",
      "symbol": "с",
      "points": 2,
      "group": "consonant",
      "weight": 4.42,
      "enabled": true,
      "sortOrder": 18
    },
    {
      "id": "ru-19",
      "symbol": "т",
      "points": 1,
      "group": "consonant",
      "weight": 6.88,
      "enabled": true,
      "sortOrder": 19
    },
    {
      "id": "ru-20",
      "symbol": "у",
      "points": 3,
      "group": "vowel",
      "weight": 2.52,
      "enabled": true,
      "sortOrder": 20
    },
    {
      "id": "ru-21",
      "symbol": "ф",
      "points": 5,
      "group": "consonant",
      "weight": 0.61,
      "enabled": true,
      "sortOrder": 21
    },
    {
      "id": "ru-22",
      "symbol": "х",
      "points": 5,
      "group": "consonant",
      "weight": 0.71,
      "enabled": true,
      "sortOrder": 22
    },
    {
      "id": "ru-23",
      "symbol": "ц",
      "points": 4,
      "group": "consonant",
      "weight": 0.96,
      "enabled": true,
      "sortOrder": 23
    },
    {
      "id": "ru-24",
      "symbol": "ч",
      "points": 4,
      "group": "consonant",
      "weight": 1.4,
      "enabled": true,
      "sortOrder": 24
    },
    {
      "id": "ru-25",
      "symbol": "ш",
      "points": 4,
      "group": "consonant",
      "weight": 0.92,
      "enabled": true,
      "sortOrder": 25
    },
    {
      "id": "ru-26",
      "symbol": "щ",
      "points": 8,
      "group": "consonant",
      "weight": 0.37,
      "enabled": true,
      "sortOrder": 26
    },
    {
      "id": "ru-27",
      "symbol": "ъ",
      "points": 10,
      "group": "consonant",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 27
    },
    {
      "id": "ru-28",
      "symbol": "ы",
      "points": 3,
      "group": "vowel",
      "weight": 2.44,
      "enabled": true,
      "sortOrder": 28
    },
    {
      "id": "ru-29",
      "symbol": "ь",
      "points": 2,
      "group": "consonant",
      "weight": 3.22,
      "enabled": true,
      "sortOrder": 29
    },
    {
      "id": "ru-30",
      "symbol": "э",
      "points": 8,
      "group": "vowel",
      "weight": 0.25,
      "enabled": true,
      "sortOrder": 30
    },
    {
      "id": "ru-31",
      "symbol": "ю",
      "points": 8,
      "group": "vowel",
      "weight": 0.28,
      "enabled": true,
      "sortOrder": 31
    },
    {
      "id": "ru-32",
      "symbol": "я",
      "points": 3,
      "group": "vowel",
      "weight": 2.01,
      "enabled": true,
      "sortOrder": 32
    }
  ]
}
